module.exports = __webpack_public_path__ + "img/checkboxcard.28de8c33.svg";